import moment, { Moment } from 'moment'
import React from 'react'
import { connect } from 'react-redux'
import { ApplicationState } from '../redux/ApplicationState'

interface Props {
    startDate: Moment
    endDate: Moment
    isCurrent: boolean
}

export class TimeRangeLabelComponent extends React.PureComponent<Props> {
    public render() {
        const { isCurrent } = this.props

        const endDate = this.props.endDate.local()
        const startDate = this.props.startDate.local()
        const duration = moment.duration(endDate.diff(startDate))
        const classes = []

        if (isCurrent) {
            if (duration.asMinutes() > 60) {
                return <span className={classes.join(' ')}>last {Math.ceil(duration.asHours())} hours</span>
            }
            return <span className={classes.join(' ')}>last {Math.ceil(duration.asMinutes())} minutes</span>
        }

        const showStartDate = !moment().isSame(startDate, 'day')
        const showEndDate = !endDate.isSame(startDate, 'day')

        const dateFormat = 'DD.MM.YYYY'
        const timeFormat = 'HH:mm'

        return (
            <span className={classes.join(' ')}>
                {showStartDate && <span className="text-muted tw-mr-4">{startDate.format(dateFormat)}</span>}
                {startDate.format(timeFormat)}
                <span className="tw-ml-4 tw-mr-4">-</span>
                {showEndDate && <span className="text-muted tw-mr-4">{endDate.format(dateFormat)}</span>}
                {endDate.format(timeFormat)}
            </span>
        )
    }
}

export default connect<Props, {}>((globalState: ApplicationState, props: {}) => {
    const range = globalState.tidewaysContext.getRange()
    return {
        startDate: range.getStartDate(),
        endDate: range.getEndDate(),
        isCurrent: range.isCurrent(),
    }
})(TimeRangeLabelComponent)
